<template>
  <v-container class="main-container responsive-height">
    <v-row dense v-if="isManager">
      <v-col cols="12">
        <v-card tile flat class="userBriefHistory pa-5"
          :class="$vuetify.theme.dark ? 'blue-darken-2' : 'white-lighten-2'">
          <!-- <BmdLink></BmdLink> -->
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card tile flat class="userBriefHistory pa-5"
          :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'">

          <TitleBarWithButton></TitleBarWithButton>
          <!-- <InfoCards></InfoCards> -->
          <v-row dense>
            <v-col cols="12" sm="6" md="3">
              <BusinessAmountCard></BusinessAmountCard>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <ClientsCard></ClientsCard>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <PartnersCard></PartnersCard>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <LiveAccountCard></LiveAccountCard>
            </v-col>
          </v-row>

        </v-card>
      </v-col>
    </v-row>
    <v-row dense class="mb-5">
      <v-col cols="12" md="7">
        <v-card tile flat class="MyTrading pa-5" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-row dense>
            <v-col cols="12">
              <TitleBar></TitleBar>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <LiveTradeCard></LiveTradeCard>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <ClosedTradeCard></ClosedTradeCard>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="5">
        <BarChart></BarChart>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <CommissionSettingsTabs></CommissionSettingsTabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BarChart from "@/components/Dashboard/BarChart.vue";
import ClosedTradeCard from "@/components/Dashboard/ClosedTradeCard.vue";
import CommissionSettingsTabs from "@/components/Dashboard/CommissionSettingsTabs.vue";
import InfoCards from "@/components/Dashboard/InfoCards.vue";
import LiveTradeCard from "@/components/Dashboard/LiveTradeCard.vue";
import TitleBar from "@/components/Dashboard/TitleBar.vue";
import TitleBarWithButton from "@/components/Dashboard/TitleBarWithButton.vue";
// import BmdLink from "@/components/Dashboard/BmdLink.vue";
import BusinessAmountCard from "@/components/Dashboard/cards/BusinessAmountCard.vue";
import ClientsCard from "@/components/Dashboard/cards/ClientsCard.vue";
import PartnersCard from "@/components/Dashboard/cards/PartnersCard.vue";
import LiveAccountCard from "@/components/Dashboard/cards/LiveAccountCard.vue";
import { mapState } from "vuex";
export default {
  data: () => ({
    forecast: [
      { day: "Deposit", icon: "mdi-tray-arrow-down", links: "/deposit" },
      { day: "Withdraw", icon: "mdi-tray-arrow-up", links: "/withdraw" },
      { day: "Transfer", icon: "mdi-swap-horizontal", links: "/transfer-form" },
      { day: "MT5 Acc.", icon: "mdi-signal", links: "/mt5" },
      {
        day: "Verification",
        icon: "mdi-account-check-outline",
        links: "/profile-verify",
      },
      { day: "Support", icon: "mdi-chat-outline", links: "/support" },
    ],
  }),

  computed: {
    ...mapState("admins", ["loggedAdmin"]),

    isManager() {
      return this.loggedAdmin && this.loggedAdmin?.access_type === "manager";
    },

  },

  components: {
    TitleBar,
    CommissionSettingsTabs,
    BarChart,
    TitleBarWithButton,
    InfoCards,
    LiveTradeCard,
    ClosedTradeCard,
    BusinessAmountCard,
    ClientsCard, 
    PartnersCard,
    LiveAccountCard,
    // BmdLink
  },
};
</script>
